export default __webpack_public_path__ + "adjust-contrast.png";